// extracted by mini-css-extract-plugin
export var currencyInput = "_o3-1";
export var currencySymbol = "_o3-0";